<template>
    <div style="max-width: 770px;">
        <Steps steps="4" current="3" links="true" />
        <form @submit.prevent="validateBeforeSubmit">
            <div class="txt-grey">Step 3</div>
            <h3 class="uc">Address Information</h3>
            <p class="light mb-4">Tell us a bit more about you and we'll be done shortly!</p>
            <fieldset class="mb-3">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <BasicInput
                            label="What's your address?"
                            id="address"
                            name="address"
                            v-model="address"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('address')" 
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-5 col-xl-4">
                       <CleaveInput
                            label="What's your zipcode?"
                            id="zipcode"
                            name="zipcode"
                            maxlength="5"
                            type="tel"
                            v-model="zipcode"
                            v-validate="{ required: true, regex: /^[0-9]{5}$/ }"
                            :exval="validationAttempt"
                            :cleaveoptions="masks.zipcode"
                            errormsg="This is a required field"
                            :error="errors.first('zipcode')" 
                        />
                    </div>
                    <div class="col-lg-5 col-xl-4">
                        <Select
                            label="What's your state?"
                            id="address_state"
                            name="address_state"
                            v-model="address_state"
                            v-validate="'required'"
                            :options="['AL','AK','AZ','CA','CO','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NC','ND','OH','OK','OR','PA','RI','SC','TN','TX','UT','VA','WA','WI','WY']"
                            errormsg="This is a required field"
                            :error="errors.first('address_state')" 
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <BasicInput
                            label="What's your city?"
                            id="city"
                            name="city"
                            v-model="city"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('city')" 
                        />
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="Time spent at this address?"
                            id="monthsAtAddress"
                            name="monthsAtAddress"
                            v-model="monthsAtAddress"
                            v-validate="'required'"
                            :options="[{value: '84', label: '7 years or more'}, {value: '72', label: '6 years'}, {value: '60', label: '5 years'}, {value: '48', label: '4 years'}, {value: '36', label: '3 years'}, {value: '24', label: '2 years'}, {value: '12', label: 'One year or less'}]"
                            errormsg="This is a required field"
                            :error="errors.first('monthsAtAddress')"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <div class="form-group mb-0">
                            <div class="mb-2 check-label">Do you own or rent?</div>
                            <div class="radio-options">
                                <div class="radio-option" :class="homeOwnership == 'rent' ? 'selected' : ''" @click="homeOwnership='rent'">
                                    I rent
                                </div>
                                <div class="radio-option" :class="homeOwnership == 'own' ? 'selected' : ''" @click="homeOwnership='own'">
                                    I own
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <fieldset class="mb-5">
                <div class="row">
                    <div class="col-lg-5 col-xl-4">
                        <BasicInput
                            label="Driver's license/State ID"
                            id="driversLicense"
                            name="driversLicense"
                            autocomplete="off"
                            v-model="driversLicense"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('driversLicense')"
                        />
                    </div>
                    <div class="col-lg-5 col-xl-4">
                        <Select
                            label="State issued"
                            id="driversLicenseState"
                            name="driversLicenseState"
                            v-model="driversLicenseState"
                            v-validate="'required'"
                            :options="['AL','AK','AZ','CA','CO','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NC','ND','OH','OK','OR','PA','RI','SC','TN','TX','UT','VA','WA','WI','WY']"
                            errormsg="This is a required field"
                            :error="errors.first('driversLicenseState')" 
                        />
                    </div>
                </div>
            </fieldset>

            <div class="my-5 d-flex align-items-center">
                <button class="btn btn-cta btn-red uc" id="form-submit">{{saving ? 'Saving...' : 'Continue'}}</button>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
            </div>
        
        </form>
    </div>
</template>

<script>
import BasicInput from '@/components/form/BasicInput.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';
import Select from '@/components/form/Select.vue';
import Steps from '@/components/form/Steps.vue';
import { mapGetters, mapActions } from "vuex";
import axios from 'axios';

export default {
    name: 'FormStep3',
    title: 'Register | Step 3',
    components:{
        BasicInput,
        CleaveInput,
        Select,
        Steps
    },
    data() {
	  return {
            validationAttempt: false,
            saving: false,

            address: '',
            zipcode: '',
            city: '',
            address_state: '',
            monthsAtAddress: '',
            homeOwnership: 'rent',
            driversLicense: '',
            driversLicenseState: '',

            masks: {
				zipcode: { numericOnly: true, blocks: [5] },
            },
		}
    },
    watch: {
        zipcode: "getZipCodes"
    },
    methods: {
        ...mapActions(['saveFormData']),
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
                        'address': this.address,
                        'zipcode': this.zipcode,
                        'city' : this.city,
                        'address_state' : this.address_state,
                        'monthsAtAddress' : this.monthsAtAddress,
                        'homeOwnership' : this.homeOwnership,
                        'driversLicense' : this.driversLicense,
                        'driversLicenseState' : this.driversLicenseState,
						'thirdStep': true,
                    });
                    this.$router.push({ path: '/registration/4' })
                    return;
                }
                this.saving = false;
				
      		});
        },
        async getZipCodes(zipcode){
            if(zipcode.length != 5){
                return
            }
            try {
                const response = await axios.get(`${process.env.VUE_APP_LOCAL_API}zipcode/${zipcode}`);
                if(response.data.found){
                    this.city = response.data.data.city;
                    this.address_state = response.data.data.state;
                } else {
                }
            } catch(err){
            }
        }
    },
    computed: {
        ...mapGetters(["formData"]),
    },
    created(){
        this.zipcode = this.formData.zipcode || '';
        this.getZipCodes(this.zipcode);

        this.address = this.formData.address || '';        
        this.monthsAtAddress = this.formData.monthsAtAddress || '';
        this.homeOwnership = this.formData.homeOwnership || 'rent';
        this.driversLicense = this.formData.driversLicense || '';
        this.driversLicenseState = this.formData.driversLicenseState || '';
  },
}
</script>

<style>
    
</style>
